import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import './main.css';
import 'swiper/css/pagination';
import image from '../assets/images/home/slider/1.jpg';
import HiJet from "./HiJet";
import {useDispatch} from "react-redux";
import {useShallowPickSelector} from "../redux";
import * as AppStore from '../redux/app'
import Slider from "../components/slider";

const Home = () => {
    const { homeState } = useShallowPickSelector('app', ['homeState'])
    const dispatch = useDispatch();

    const onStartPressFn = () => {
        dispatch(AppStore.actions.setHomeState(false))
    }

    return (
        <div className="container">
            {homeState && <div className="home-hiJetContainer justifyStartImportant">
                <div className="w100 home-sliderContainer home-extra-sliderContainer maxW768">
                    <Slider/>
                </div>
                <div className="home-textContainer">
                    <h5 className="font-bold fs16 text-center">
                        Welcome to JetApp
                    </h5>
                    <p className="text-center">
                        Ready to earn Jet Points (JPs)? Tap, score, and earn big with Hi Jet!
                    </p>
                    <button type="button" className="button home-startBtn" onClick={onStartPressFn}>
                        <span className="text-white py10-1">Let's go!</span>
                    </button>
                    <p className="font-bold fs16 mt30 text-left">
                        Do. Earn. Multiply.
                    </p>
                    <p className="text-left">
                        Every task you complete brings you closer to stacking up valuable $JETs. And it doesn’t stop there! Invite your friends to join the action, and you’ll both score even more points. The bigger the team, the bigger the earnings.
                    </p>
                </div>
            </div>}
            {!homeState && <div className="home-hiJetContainer">
                <HiJet/>
                <div className="w100 home-sliderContainer home-extra-sliderContainer maxW768">
                    <Slider />
                </div>
            </div>}
            <div className="h50"></div>
        </div>
    );
}

export default Home;
